export const UNIT_SYSTEM = {
  US: 'US',
  IS: 'IS',
} as const;

export const AREA_UNIT_LABEL = {
  US: 'sq ft',
  IS: 'sq m',
} as const;

export const RATE_PER_AREA_UNIT_LABEL = {
  US: 'per sq ft',
  IS: 'per sq m',
} as const;

export const AREA_UNIT_FULL_LABEL = {
  US: 'Square Footage',
  IS: 'Square Meters',
} as const;
